import React from 'react';
import api from './api';
import './Doctors.css';
import {Link, Navigate, useNavigate} from "react-router-dom"

import useAuth from "../hooks/useAuth";
import { isSuper } from '../utils/canDo';
import {
    useState,
    useEffect
} from 'react';

const PreConsultation = ({patientCard, onTabClose }) => {
    const { auth } = useAuth();
  const [patients, setPatients] = useState([]);
  const [newPatient, setNewPatient] = useState({ name: '', age: '', gender: 'male', address: "", number:"", patientCard: "", registrationDate: new Date() });
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [isEditMode, setIsEditMode] = useState(true);
    const navigate = useNavigate()
    useEffect(
      () => {

          api.get(`${process.env.REACT_APP_URL}/patients/preconsultation/${patientCard}`)
              .then(response => {
                //console.log("from mongo fetch",response.data);
                setSelectedPatient(response.data)
              })
              .catch(error =>
                  console.error('Error fetching patients:', error));
      }, []);


        const handleAddPatient =
        (e) => {
            e.preventDefault();
            //console.log("button clicked == ", e.target)
            api.post(
`${process.env.REACT_APP_URL}/patients/preconsultation/add`, newPatient)
                .then(response => {
                    //console.log(response.data);
                    setPatients([...patients, response.data]);
                    setNewPatient({});// name: '', age: '', gender: '' });
                })
                .catch(error =>
                    console.error('Error adding patient:', error));
        };

    const handleUpdatePatient =
        (id, e) => {
            e.preventDefault();
            //console.log("button clicked == ", e.target.id, selectedPatient)
            api.post(
              `${process.env.REACT_APP_URL}/patients/preconsultation/${patientCard}`, selectedPatient)
                .then(response => {
                    const updatePat = {
                        ...selectedPatient,
                    };
                    alert("PreConsultation updated successfully !")
                    //setSelectedPatient(null);
                    //setIsEditMode(false); // Switch back to Add mode
                    handleClose();
                })
                .catch(
                    error =>
                        console.error('Error updating patient:', error));
        };

const handleClose = () => {
    if (isSuper(auth))
    { return;
    }

  onTabClose(true);
  return;

}

  const field = (label, input) => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      <label style={{ fontSize: 12, fontWeight: 600, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
        {label}
      </label>
      {input}
    </div>
  );

  const inputStyle = {
    padding: '9px 12px',
    border: '1.5px solid #e5e7eb',
    borderRadius: 8,
    fontSize: 14,
    color: '#1f2937',
    outline: 'none',
    width: '100%',
    boxSizing: 'border-box',
    background: '#fafafa',
    transition: 'border-color 0.15s',
  };

  const val = (key) => isEditMode ? (selectedPatient && selectedPatient[key] ? selectedPatient[key] : '') : '';
  const onChange = (key) => (e) => {
    if (isEditMode) setSelectedPatient({ ...selectedPatient, [key]: e.target.value });
    else setNewPatient({ ...newPatient, [key]: e.target.value });
  };

  return (
    <div style={{ maxWidth: 640, margin: '0 auto', padding: '4px 0' }}>
      <div style={{
        background: '#fff',
        borderRadius: 12,
        border: '1px solid #e5e7eb',
        boxShadow: '0 2px 10px rgba(0,0,0,0.06)',
        overflow: 'hidden',
      }}>
        {/* Card header */}
        <div style={{
          padding: '14px 20px',
          borderBottom: '1px solid #f3f4f6',
          display: 'flex',
          alignItems: 'center',
          gap: 10,
        }}>
          <div style={{
            width: 32, height: 32, borderRadius: 8,
            background: 'linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 15, color: '#fff', flexShrink: 0,
          }}>🩺</div>
          <div>
            <div style={{ fontSize: 14, fontWeight: 700, color: '#1e3a5f' }}>Pre-Consultation Vitals</div>
            <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 1 }}>Record patient vitals before session</div>
          </div>
        </div>

        {/* Form body */}
        <form onSubmit={isEditMode ? (e) => handleUpdatePatient(selectedPatient && selectedPatient._id, e) : handleAddPatient}
          style={{ padding: '20px 24px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px 20px' }}>
            {field('Weight',
              <input
                type="text"
                style={inputStyle}
                value={val('weight')}
                onChange={onChange('weight')}
              />
            )}
            {field('Height',
              <input
                type="text"
                style={inputStyle}
                value={val('height')}
                onChange={onChange('height')}
              />
            )}
            {field('Blood Pressure (mmHg)',
              <input
                type="text"
                style={inputStyle}
                placeholder="e.g. 120/80"
                value={val('bp')}
                onChange={onChange('bp')}
              />
            )}
            {field('Pulse (bpm)',
              <input
                type="number"
                style={inputStyle}
                placeholder="e.g. 72"
                value={val('pulse')}
                onChange={onChange('pulse')}
              />
            )}
            {field('O₂ Saturation in Blood',
              <input
                type="text"
                style={inputStyle}
                value={val('o2')}
                onChange={onChange('o2')}
              />
            )}
          </div>

          <div style={{ marginTop: 24, display: 'flex', justifyContent: 'flex-end' }}>
            <button
              type="submit"
              id="data"
              style={{
                padding: '10px 28px',
                background: 'linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%)',
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                fontSize: 14,
                fontWeight: 700,
                cursor: 'pointer',
                letterSpacing: '0.02em',
              }}
            >
              {isEditMode ? 'Save / Update Vitals' : 'Save Vitals'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default PreConsultation;
